const base_url = process.env.REACT_APP_BASE_URL

/** Call sites append straight onto this, so it has to end with exactly one. */
const withTrailingSlash = (value) => (value ? String(value).replace(/\/+$/, "") + "/" : "")

/**
 * TEMPORARY - the Production Toolkit gateway, pinned in code.
 *
 * `REACT_APP_PROD_MODULE_API_GATEWAY_URL` is set on developer machines but not
 * in the stage build, so on stage every Production Toolkit request went out
 * with a missing prefix. Pinning the value keeps those screens working while
 * that build's environment is sorted out.
 *
 * What this costs, deliberately and for now:
 *  - every environment calls staging, production included;
 *  - the variable is still read below, but only to be logged, not used.
 *
 * To undo: delete `PROD_MODULE_URL` and the `console.log` in
 * `pages/GasDistribution/index.js`, and put back
 *   const prodModule = withTrailingSlash(process.env.REACT_APP_PROD_MODULE_API_GATEWAY_URL)
 *
 * Note the path: call sites append a bare endpoint (`${prodModule}zig-count/`),
 * so the whole `/assets/api/v1/` prefix has to live here.
 */
const PROD_MODULE_URL = "https://staging-new-api-gas.polarisgrids.com/assets/api/v1/"

const prodModule = withTrailingSlash(PROD_MODULE_URL)

/** What the build baked in, for the stage console - see the note above. */
export const PROD_MODULE_ENV_URL = process.env.REACT_APP_PROD_MODULE_API_GATEWAY_URL

const api_url = {
  base_url,
  url: base_url.concat("/") + process.env.REACT_APP_OTHER_MODULES_URL,
  loginUrl: base_url.concat("/") + process.env.REACT_APP_LOGIN_URL,
  thinkGasHes: base_url.concat("/") + process.env.REACT_APP_THINK_GAS_HES,
  /**
   * Staff SSO, rebuilt: `/sso/api/v1/staff`.
   *
   * Replaces the flat `/sso/...` routes the auth screens called. It lives
   * here rather than being spelled out per call because every staff endpoint
   * hangs off it — auth today, and the role, user and catalog APIs when
   * those screens follow.
   *
   * No trailing slash: call sites append a rooted path (`/auth/login`).
   */
  ssoStaff: base_url.concat("/sso/api/v1/staff"),
  prodModule
}

export default api_url
